import React, {useState} from 'react';
import MainOptionsMaterialModuleEntityTextField from "./MainOptionsMaterialModuleEntityTextField";
import {Button, DialogContent, Stack, Typography} from "@mui/material";
import TextFieldWithSetValueMainOptions from "./TextFieldWithSetValueMainOptions";
import Box from "@mui/material/Box";
import MaterialTextFieldObjectWithEntityList from "./MaterialTextFieldObjectWithEntityList";
import {typesMaterial} from "../../../../data/TypeMaterial";
import {structure} from "../../../../data/Structure";
import {statusesYesOrNo} from "../../../../data/StatusesYesOrNo";
import TextFieldArrivalMaterialModuleItem from "../arrivalmaterialmoduleitem/TextFieldArrivalMaterialModuleItem";
import ButtonAdd from "../../button/ButtonAdd";
import ButtonCreate from "../../button/ButtonCreate";
import ModalAddMaterial from "../../table/orders/organization/estimate/ModalAddMaterial";
import MaterialOrganizationOptionService
    from "../../../../API/orders/warehouse/material/MaterialOrganizationOptionService";
import {useNavigate} from "react-router-dom";
import TextFieldValidation from "../../table/customer-detales/TextFieldValidation";

const CloudOptionsMaterialModule = ({
                                        id,
                                        materialId,
                                        data,
                                        setData,
                                        supplierList,
                                        groupMaterialList,
                                        manufacturerList,
                                        handleSubmit,
                                        setSupplierId,
                                        setManufacturerId,
                                        setGroupMaterialId,
                                        baseUnit,
                                        changeOptionsDisabled,
                                        isMaterialOrganizationOption,
                                        isSettings,
                                        handleModalAlert,
                                        typeMaterial
                                    }) => {
    const navigate = useNavigate();
    const isSlab = isMaterialOrganizationOption ? data && data.typeMaterial === 'SLAB' : data && data.typeMaterial === 'SLAB';
    const setId = (type, id) => {
        setData(prev => ({...prev, [type]: {id: id}}))
    }
    const [materialModal, setMaterialModal] = useState(false);
    const [loading, setLoading] = useState(false)

    const handleCloseMaterialModal = () => {
        setMaterialModal(false)
    }
    const handleBindMaterial = (value, close) => {
        setLoading(true)
        MaterialOrganizationOptionService.bindMaterial(id, value?.material?.id)
            .then(function (response) {
                navigate(`/organization/materials/${id}/${baseUnit}/${typeMaterial}/${value?.material?.id}`);
                response?.data && setData(response?.data)
                close()
                handleModalAlert("Материал привязан", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    return (

        <DialogContent sx={{padding: "5px 0"}}>

            <Box sx={{paddingBottom: "20px"}}>
                {isMaterialOrganizationOption && <ButtonCreate
                    text={"Привязать материал из облака"} width={"290px"}
                    onClick={() => setMaterialModal(true)}
                />}
            </Box>

            {materialId === "null" ? <Typography>Данный материал отсутствует в облаке</Typography> :
                <form onSubmit={(e) => e.preventDefault()}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        "& > *:not(:last-child)": {marginRight: '20px'}
                    }}>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                maxWidth: '500px',
                            }}
                        >
                            <TextFieldWithSetValueMainOptions
                                label="Артикул"
                                values={data}
                                setValues={setData}
                                field={'articleNumber'}
                                disabled={changeOptionsDisabled}
                            />
                            <TextFieldWithSetValueMainOptions
                                label="Наименование по умолчанию"
                                values={data}
                                setValues={setData}
                                field={'name'}
                                disabled={changeOptionsDisabled}
                            />
                            <TextFieldValidation
                                name={"defaultSupplier"}
                                type={"text"}
                                value={data?.defaultSupplier?.name}
                                label={"Поставщик по умолчанию"}
                                disabled={true}
                                margin={"normal"}
                            />
                            <TextFieldArrivalMaterialModuleItem
                                label="Ед. измерения"
                                value={baseUnit}
                                field={baseUnit}
                                maxWidth={'600px'}
                                disabled={true}
                            />
                            <MaterialTextFieldObjectWithEntityList
                                label="Тип материала"
                                values={data}
                                setValues={setData}
                                field={'typeMaterial'}
                                entityList={typesMaterial}
                                disabled={changeOptionsDisabled}
                            />
                            {manufacturerList && <MainOptionsMaterialModuleEntityTextField
                                label={'Производитель'}
                                values={data}
                                field={'manufacturer'}
                                childFirstField={'id'}
                                setId={(id) => setId("manufacturer", id)}
                                entityList={manufacturerList}
                                disabled={changeOptionsDisabled}
                            />}
                            {<MaterialTextFieldObjectWithEntityList
                                label="Архив"
                                values={data}
                                setValues={setData}
                                field={'archive'}
                                entityList={statusesYesOrNo}
                                disabled={changeOptionsDisabled}
                            />}
                        </Stack>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                maxWidth: '200px',
                            }}
                        >
                            {isSlab && <Box sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                            }}>
                                <TextFieldWithSetValueMainOptions
                                    label="Ширина"
                                    values={data}
                                    setValues={setData}
                                    field={'length'}
                                    marginRight={'10px'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                                <TextFieldWithSetValueMainOptions
                                    label="Высота"
                                    values={data}
                                    setValues={setData}
                                    field={'width'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                            </Box>}
                            {isSlab && <Box sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                            }}>
                                <TextFieldWithSetValueMainOptions
                                    label="Толщина"
                                    values={data}
                                    setValues={setData}
                                    field={'thickness'}
                                    marginRight={'10px'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                                <TextFieldWithSetValueMainOptions
                                    label="Плотность"
                                    values={data}
                                    setValues={setData}
                                    field={'density'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                            </Box>}
                            {isSlab && <MaterialTextFieldObjectWithEntityList
                                label="Структура"
                                values={data}
                                setValues={setData}
                                field={'structure'}
                                entityList={structure}
                                disabled={changeOptionsDisabled}
                            />}
                            {isSlab && <Box sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                            }}>
                                <TextFieldWithSetValueMainOptions
                                    label="Отсуп слева"
                                    values={data}
                                    setValues={setData}
                                    field={'trimmingLeft'}
                                    marginRight={'10px'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                                <TextFieldWithSetValueMainOptions
                                    label="Отсуп справа"
                                    values={data}
                                    setValues={setData}
                                    field={'trimmingRight'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                            </Box>}
                            {isSlab && <Box sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                maxWidth: '100%',
                            }}>
                                <TextFieldWithSetValueMainOptions
                                    label="Отсуп снизу"
                                    values={data}
                                    setValues={setData}
                                    field={'trimmingBottom'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    marginRight={'10px'}
                                    disabled={changeOptionsDisabled}
                                />
                                <TextFieldWithSetValueMainOptions
                                    label="Отсуп сверху"
                                    values={data}
                                    setValues={setData}
                                    field={'trimmingTop'}
                                    minWidthXS={'25px'}
                                    minWidthSM={'25px'}
                                    minWidthPX={'25px'}
                                    disabled={changeOptionsDisabled}
                                />
                            </Box>}
                        </Stack>
                    </Box>
                    <Box sx={{width: 920, paddingTop: "20px", display: "flex", justifyContent: "flex-end"}}>
                        {!changeOptionsDisabled && isSettings && <ButtonAdd text={"Сохранить"} onClick={handleSubmit}/>}
                    </Box>
                </form>}
            <ModalAddMaterial
                open={materialModal}
                title={"Привязать материал из облака"}
                materialCloud={true}
                onClose={handleCloseMaterialModal}
                handleSubmit={handleBindMaterial}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
        </DialogContent>
    );
};

export default CloudOptionsMaterialModule;